import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectDto, ProjectResolved } from 'shared';
import { PROJECTTABS, SquirrelTabs } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'edit-project',
    templateUrl: './edit-project.component.html',
    styleUrls: ['./edit-project.component.scss'],
    standalone: false
})
export class EditProjectComponent implements OnInit {

  projectDto!:ProjectDto;
  tabs: SquirrelTabs[] = [];

  constructor(private route: ActivatedRoute,
    public translate: TranslateService) { }

  ngOnInit(): void {

    this.tabs = PROJECTTABS;

    this.route.data.subscribe({
      next: (data:any) => {
        const resolvedData: ProjectResolved = data['resolvedData'];
        this.projectDto = resolvedData.projectDto;
      },
      //error
    });
  }
}
